import React from "react";
import logger from "logger";

const scope = {};

export const DialogProvider = () => {
  const [dialog, setDialog] = React.useState(null);
  scope.setDialog = setDialog;
  return dialog;
};

export const showDialog = (component) => {
  scope.setDialog(component);
};
